// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { TemplateDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class TemplateApiClient extends BaseCRUDApiClient<TemplateDto> {
  baseUrl = this.config.apiEndpoint + '/template';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  getAvailableTemplateList(tipologia: string) {
    return this.http.get<{ templates: TemplateDto[]; esercizio: number }>(
      `${this.baseUrl}/available-template-list/${tipologia}`
    );
  }
}
